module.exports = __webpack_public_path__ + "static/img/30.df0a70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/30.png
// module id = MC+q
// module chunks = 0